import { HemisphericLight, Vector3 } from 'babylonjs';
import { IAssetBase } from './eyejack-web-core/src/core/loader/loader';
import { AppImmersalConfig } from './eyejack-web-core/src/apps/app.immersal';
import AppImmersalWebXR from './eyejack-web-core/src/apps/app.immersal.webxr';
import events from '../events';
import WSBridge, { WSBridgeOptions } from './eyejack-web-core/src/core/bridge-ws/bridge.ws';
import emitter from "./eyejack-web-core/src/core/events/eventemitter";
import { WSBridgeCameraImageType, WSBridgeDataUpdatePolicy } from './eyejack-web-core/src/core/bridge-ws/bridge.ws.types';
import { IS_EYEJACK_WEBXR_POLYFILL } from './eyejack-web-core/src/core/utils/utils';
import ContentEmpty from './content/content.empty';

export class MainBase extends AppImmersalWebXR {

  protected content?: ContentEmpty | null = null;
  private wsBridge?: WSBridge | null = null;

  constructor(configImmersal:AppImmersalConfig, content?:ContentEmpty) {
    const renderCanvas = <HTMLCanvasElement>(document.getElementById('renderCanvas'));
    super(renderCanvas);
    //
    this.setConfigImmersal(configImmersal);
    //
    events.on('play', () => {
      this.content?.play();
    });
    events.on('stop', () => {
      this.content?.stop();
    });
    emitter.on('xr-started', () => {
      this.wsBridgeInit();
    })
    this.content = content;
  }

  private wsBridgeInit() {
    if( !IS_EYEJACK_WEBXR_POLYFILL ) {
      return;
    }
    if (this.wsBridge) {
      return;
    }
    const options: WSBridgeOptions = {
      frameStartCallback: this.wsBridgeFrameStart.bind(this),
      frameEndCallback: this.wsBridgeFrameEnd.bind(this),
    }
    this.wsBridge = new WSBridge(options);
    this.wsBridge.cameraDataUpdatePolicy = WSBridgeDataUpdatePolicy.Always; // None, Once or Always.
    this.wsBridge.cameraImageType = WSBridgeCameraImageType.JPEG; // JPEG or PNG.
    this.wsBridge.cameraImageScale = 0.25; // between 0.0 and 1.0
    this.wsBridge.cameraImageQuality = 0.75; // between 0.0 and 1.0
    this.wsBridge.init();
  }

  private wsBridgeFrameStart() {
    // nothing.
  }

  private wsBridgeFrameEnd() {
    // nothing.
  }

  protected override initialize() {
    super.initialize();
    //
    const light = new HemisphericLight('light', new Vector3(0, 1, 0), this.scene);
    light.intensity = 0.7;
    //
    this.content?.init(this.engine!, this.scene!, this.camera!);
  }

  public override render(): void {
    super.render();
    this.content?.render();
  }

  public override async loadAsync() {
    await super.loadAsync();
    await this.loadContents(this.content?.assets || []); 
  }

  protected override loadAssetComplete(asset: IAssetBase) {
    console.log('loadAssetComplete', asset.path);
    this.content?.loadAssetComplete( asset );
  }
}